module.exports = __webpack_public_path__ + "img/eth_network_nft_details.ce041533.svg";